import * as React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Loading from './Loading';
import { loginUrl } from '../../api/auth';

const redirect = () => {
    window.location.assign(loginUrl);
    return (
        <Typography align="center">Redirecting to login...</Typography>
    )
}

interface Props extends RouteProps {
	render?: (props: any) => React.ReactElement<any>;
    authenticated: boolean;
    authenticating: boolean;
}

const PrivateRoute = ({
	render,
	component: Component,
	authenticated,
	authenticating,
	...rest
} : Props) => (
	<Route
		{...rest}
		render={props => {
			if (authenticating) {
				return <Loading />;
			} else if (!authenticated) {
				return <Route component={redirect} />;
			} else {
				return render ? render(props) : Component ? <Component {...props} /> : null;
			}
		}}
	/>
);

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/components/Common/ProtectedRoute.tsx